import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-rooftop',
  standalone: true,
  templateUrl: './rooftop.html',
  styleUrl: './rooftop.css'
})
export class RooftopComponent implements AfterViewInit, OnDestroy {
  @ViewChild('lgContainer') lgContainer!: ElementRef;

  private platformId = inject(PLATFORM_ID);
  private lgInstance: any = null;
  private lgSetupPromise: Promise<void> | null = null;

  readonly images = [
    { src: '/exterior/pool_1.webp', alt: 'Rooftop sanctuary at Acacia',   label: 'Panoramic Skyline' },
    { src: '/exterior/rooftop_3.webp', alt: 'Rooftop sanctuary at Acacia',   label: 'Panoramic Skyline' },
    { src: '/exterior/rooftop_2.webp',       alt: 'Elevated terrace at Acacia',       label: 'Elevated Terrace' },
    { src: '/exterior/pool_5.webp',       alt: 'Sky garden at Acacia',             label: 'Sky Garden' },
    { src: '/exterior/pool_ai_1.webp',       alt: 'Horizon infinity pool',            label: 'Horizon Pool' },
    { src: '/exterior/pool_ai_2.webp',       alt: 'Poolside at Acacia rooftop',       label: 'Poolside' },
  ];

  async ngAfterViewInit() {
    await this.ensureLightGallery();
  }

  async openAt(index: number) {
    await this.ensureLightGallery();
    this.lgInstance?.openGallery(index);
  }

  ngOnDestroy() {
    this.lgInstance?.destroy();
  }

  private ensureLightGallery(): Promise<void> {
    if (!isPlatformBrowser(this.platformId) || this.lgInstance) {
      return Promise.resolve();
    }

    if (!this.lgSetupPromise) {
      this.lgSetupPromise = Promise.all([
        import('lightgallery'),
        import('lightgallery/plugins/zoom'),
        import('lightgallery/plugins/fullscreen')
      ]).then(([{ default: lightGallery }, { default: lgZoom }, { default: lgFullscreen }]) => {
        this.lgInstance = lightGallery(this.lgContainer.nativeElement, {
          plugins: [lgZoom, lgFullscreen],
          dynamic: true,
          dynamicEl: this.images.map(img => ({ src: img.src, alt: img.alt })),
          speed: 500,
          zoom: true,
          download: false,
          counter: true,
        });
      });
    }

    return this.lgSetupPromise;
  }
}
